import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const ButtonsContainer = styled(Col_)`
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
`;

export const Col = styled(Col_)`
    margin-bottom: 10px;
`;

export const Row = styled(Row_)`

`;
